import { tint, shade, invert } from "polished";
// invertTheme.js

const colors = {
  text: "#fff",
  violet: "#7673c0",
  ash: "#363636",
  blue: "#4698CB",
  green: "#1CAB42",
  pink: "#E56DB1",
  orange: "#DF4A17",
  yellow: "#ED8B00",
  lightgrey: "#EBEBEB",
  dark: {
    violet: shade(0.75, "#7673c0"),
    blue: shade(0.75, "#4698CB"),
    green: shade(0.75, "#1CAB42"),
    pink: shade(0.75, "#E56DB1"),
    orange: shade(0.75, "#DF4A17"),
    yellow: shade(0.75, "#ED8B00")
  },
  light: {
    violet: tint(0.75, "#7673c0"),
    blue: tint(0.75, "#4698CB"),
    green: tint(0.75, "#1CAB42"),
    pink: tint(0.75, "#E56DB1"),
    orange: tint(0.75, "#DF4A17"),
    yellow: tint(0.75, "#ED8B00")
  },
  grey: ["#fff", invert("#EBEBEB"), "#363636"]
};

const shadows = [`0 1px 2px 0 ${colors.text}`, `0 1px 4px 0 ${colors.text}`];

const invertTheme = {
  colors,
  shadows
};

export default invertTheme;



// WEBPACK FOOTER //
// ./src/invertTheme.js